core.constant('wizardMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "MESSAGE": {
        }
      },
      "UI": {
        "APPLICATION": {
          "FILL_MY_DATA" : "Wypełnij moje dane",
          "CONTINUE_WITHOUT_FILLING" : "Kontynuuj bez wypełnienia"
        },
        "TABBAR": {
          "WIZARD": {
            "FILL_YOUR_DATA": "Krok 1: Uzupełnij swoje dane",
            "ADD_OFFICE": "Krok 2: Dodaj dane gabinetu",
            "PRICE_LIST": "Krok 2: Uzupełnij cennik",
            "WELCOME_HOURS": "Krok 3: Godziny przyjęć"
          }
        }
        },
      "MODULE": {
        "TITLE": {
          "WIZARD": "Uzupełnianie danych"
        },
        "WIZARD": {
        },
        "WELCOME": {
          "WELCOME_IN_MEEDY_DOCTORS" : "Witaj w Meedy Doctors",
          "ALL_DATA_IN_ONE_PLACE" : "Wszystkie dane Twoich pacjentów w jednym miejscu.",
          "REQUEST": {
            "P1" : "Prosimy Cię o poświęcenie kilku minut i ",
            "LINK" : "wypełnienie danych",
            "P2" : "wymaganych przez ustawę o Elektronicznej Dokumentacji Medycznej. Bez nich nie będziesz mógł skorzystać z pełnej funkcjonalności serwisu."
          },
          "CAN_FILL_DATA" : "Możesz uzupełnić je później w zakładce ",
          "WHERE_FILL_DATA" : "Ustawienia -> Moje Dane"
        }
      }
    }
  }
});
